export enum ProductLevel{
    Department = 'Department',
    SubDepartment = 'SubDepartment',
    Category = 'Category',
    SubCategory = 'SubCategory',
}
